import { combineReducers } from "redux";
import SslReducer from "./SslReducer";
import CardDetailsReducer from "./CardDetailsReducer";
import MasterDataReducer from "./MasterDataReducer";
import UserReducer from "./UserReducer";
import AppStateReducer from "./AppStateReducer";
import CardListReducer from "./CardListReducer";
import DigiLockerReducer from "./DigiLockerReducer";
import ResiAddressReducer from "./ResiAddressReducer";
import NavReducer from "./navReducers";
import PenyDropReducer from "./PenyDropReducer";
import TakePhotoReducer from './TakePhotoReducer';
import MidMitcReducer from "./MidMitcReducer";
import PanUploadReducer from './PanUploadReducer';
import WIPReducer from "./WIPReducer";
import PartnerReducer from "./PartnerReducer";
import TelcoReducer from "./TelcoReducer";
import IncomeSurrogateReducer from "./IncomeSurrogateReducer";
import EkycReducer from "./EkycReducer";
import IndigoFFNReducer from "./IndigoFFNReducer";
import DumpDataReducer from "./DumpDataReducer";

const allReducers = combineReducers({
  SSL: SslReducer,
  MasterData: MasterDataReducer,
  User: UserReducer,
  AppState: AppStateReducer,
  EligibleCardList: CardListReducer,
  DigiLocker: DigiLockerReducer,
  ResiAdd: ResiAddressReducer,
  AppNav: NavReducer,
  PenyDrop: PenyDropReducer,
  TakePhoto: TakePhotoReducer,
  MidMitc: MidMitcReducer,
  PanUpload: PanUploadReducer,
  WIPStatusCode: WIPReducer,
  Partner:PartnerReducer,
  CardDetails:CardDetailsReducer,
  Telco:TelcoReducer,
  IncomeSurrogate:IncomeSurrogateReducer,
  EkycDetails:EkycReducer,
  IndigoFFN:IndigoFFNReducer,
  DumpData: DumpDataReducer
  // In this function, a peiece of a state is mapped to their
  // corresponding Reducer. This mapping will be used in our React components to access information
  // from a particular piece of state
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_APP') {
    const { AppState } = state;
    state = { AppState };
  }

  return allReducers(state, action);
};

export default rootReducer;
